// extracted by mini-css-extract-plugin
export default {"container":"PopUpModal_container__P-Wej","closeModalIcon":"PopUpModal_closeModalIcon__Gq+a6"};